import { authenticatedFetch } from '../../../shared/utils/authenticatedFetch';
import type { TrackingData } from '../types/taTracking';

/**
 * TA Cockpit → Tracking.
 *
 * Sits on the ta-demand prefix because every figure it reads is a Hiring
 * Database figure — the same table, the same period scoping and the same frozen
 * baselines the Hiring demand board uses. A second reader would eventually be a
 * second answer to how many people TA has hired.
 */
const PROXY_URL =
  import.meta.env.VITE_PROXY_URL ||
  'https://proxy-prod-520260363689.europe-west3.run.app';

export async function fetchTracking(period: string): Promise<TrackingData> {
  const res = await authenticatedFetch(
    `${PROXY_URL}/api/ta-demand/${encodeURIComponent(period)}/tracking`,
  );
  if (!res.ok) {
    let detail = '';
    try {
      const body = await res.json();
      detail = body?.detail || body?.error || '';
    } catch {
      /* a non-JSON error body tells us nothing useful */
    }
    throw new Error(detail || `Tracking fetch failed (${res.status})`);
  }
  return res.json() as Promise<TrackingData>;
}
